import styles from "./CreatorsPage.module.scss";
import Apply from "./creatorsPage/Apply";
import { Footer, Nav } from "./creatorsPage/Chrome";
import Earn from "./creatorsPage/Earn";
import FlowDemo from "./creatorsPage/FlowDemo";
import Hero from "./creatorsPage/Hero";
import { SMarkSprite } from "./creatorsPage/icons";
import Make from "./creatorsPage/Make";
import { Affiliate, ChatGpt, Faq, Meet, Promo, Why, YourPage } from "./creatorsPage/Sections";

/**
 * `/creators` — the page that recruits creators (bloggers, influencers): what they earn, what they can
 * make, and the application form. A port of the approved static build (stippl-knowledge
 * `work/creators-page/`); spec: `work/creators-page.md`.
 *
 * Standalone on purpose, like /links: it has its own nav and footer instead of the site's. Light only
 * and English only. The calculator, the "+€0.50" pop-ups and the "Your links this month" amounts are
 * labelled examples, not data.
 */
const CreatorsPage = () => (
	<div className={styles.root} id="stippl-creators">
		<SMarkSprite />
		<Nav />
		<main id="top">
			<Hero />
			<Why />
			<Affiliate />
			<FlowDemo />
			<Earn />
			<Make />
			<YourPage />
			<Promo />
			<ChatGpt />
			<Meet />
			<Faq />
			<Apply />
		</main>
		<Footer />
	</div>
);

export default CreatorsPage;
